import { render, staticRenderFns } from "./PraticaTrasportoPrincipaleAereo.vue?vue&type=template&id=75134060&scoped=true&"
import script from "./PraticaTrasportoPrincipaleAereo.vue?vue&type=script&lang=js&"
export * from "./PraticaTrasportoPrincipaleAereo.vue?vue&type=script&lang=js&"
import style0 from "./PraticaTrasportoPrincipaleAereo.vue?vue&type=style&index=0&id=75134060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75134060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75134060')) {
      api.createRecord('75134060', component.options)
    } else {
      api.reload('75134060', component.options)
    }
    module.hot.accept("./PraticaTrasportoPrincipaleAereo.vue?vue&type=template&id=75134060&scoped=true&", function () {
      api.rerender('75134060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaTrasportoPrincipaleAereo.vue"
export default component.exports